import { useMemo } from 'react';
import { useCreateEvaluationGradeEntryBase } from './../../../Loaders/CreateEvaluationGradeEntryBaseLoader';

enum StructureTypeCodeString {
  FREE = 'free',
  FIXED = 'fixed',
  SEMIFIXED = 'semi-fixed',
}

const useStructureTypeIsFixed = () => {
  const { data } = useCreateEvaluationGradeEntryBase();
  const structureTypeCode = data?.sectionData?.StructureType_code;

  const isFreeType = useMemo(() => {
    return !structureTypeCode
      ? true
      : structureTypeCode === StructureTypeCodeString.FREE;
  }, [structureTypeCode]);

  const isSemiFixedType = useMemo(() => {
    return (
      !!structureTypeCode &&
      structureTypeCode === StructureTypeCodeString.SEMIFIXED
    );
  }, [structureTypeCode]);

  const isFixedType = useMemo(() => {
    return (
      !!structureTypeCode && structureTypeCode === StructureTypeCodeString.FIXED
    );
  }, [structureTypeCode]);

  return {
    isFreeType,
    isSemiFixedType,
    isFixedType,
  };
};

export default useStructureTypeIsFixed;
